module.exports = __webpack_public_path__ + "static/media/info.ae3de156.svg";